var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.tag,{tag:"component",staticClass:"mdc-chip-set",class:{
    'mdc-chip-set--choice':_vm.choice,
    'mdc-chip-set--filter':_vm.filter,
    'mdc-chip-set--input':_vm.input,
  }},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }